//@flow

// Vendors
import React from 'react';
import { ButtonPrimary } from 'texkit/dist/components/Buttons';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';

// Components
import { Modal } from '../../modals';
import Trans from '../../Trans/Trans';

//Actions
import { closeModal } from '../../../../reducers/modal/modalActions';
import { clearLinkServiceData } from '../../../../reducers/agency/linkService/linkServiceActions';
import { selectModalData } from '../../../../reducers/modal/modalSelectors';

const DpsLinkingLockoutModal = () => {
  const dispatch = useDispatch();
  const { isDlrLockout = false } = useSelector(selectModalData) || {};

  const goToDashboard = () => {
    dispatch(clearLinkServiceData());
    dispatch(push('/dashboard'));
  };

  return (
    <Modal
      name="DpsLinkingLockoutModal"
      onClose={goToDashboard}
      disableCloseButton
    >
      <h2 className="h1 modal-title">
        <Trans
          file="Modals"
          id={
            isDlrLockout
              ? 'Linking_DLR_Lockout_Header'
              : 'Linking_Lockout_Header'
          }
          fallback={
            isDlrLockout
              ? 'Driver license (DL) or ID services temporarily locked'
              : "We weren't able to verify your information"
          }
        />
      </h2>
      <div className="modal-content">
        <Trans
          file="Modals"
          id={
            isDlrLockout ? 'Linking_DLR_Lockout_Body' : 'Linking_Lockout_Body'
          }
          fallback={
            isDlrLockout
              ? 'There were too many unsuccessful attempts for this request. To protect your personal information, we locked your access to link a driver license or ID card for 24 hours.'
              : "There have been too many unsuccessful attempts to verify your information. To protect your personal information, you won't be able to try again for 24 hours."
          }
        />
      </div>
      <ButtonPrimary
        className="modal-close-button "
        onClick={() => {
          dispatch(closeModal('DpsLinkingLockoutModal'));
          goToDashboard();
        }}
      >
        <Trans
          file={isDlrLockout ? 'Labels' : 'Modals'}
          id={isDlrLockout ? 'ReturnToDashboard' : 'Ok'}
          fallback={isDlrLockout ? 'Back to TxT Dashboard' : 'OK, got it'}
        />
      </ButtonPrimary>
    </Modal>
  );
};

export default DpsLinkingLockoutModal;
